import React, { useState, useContext, useMemo } from "react"
import {
    Box,
    FormControl,
    Select,
    MenuItem,
    ListSubheader,
    TextField,
    InputAdornment
} from "@mui/material"
import { KeyboardArrowDown, Search } from "@mui/icons-material"
import { sxSelect, sxMenuPaper } from "./ComboBoxSx"
import { EventosContext } from "../../../Providers/EventosContext/EventosContext"

const Teste = (text, searchText) => text.toLowerCase().indexOf(searchText.toLowerCase()) > -1

export default function ComboBoxHashtag({ name, options, label = "descricao", labelId = "id", onChange, defaultValue = 0, disabled = false, ...rest }) {
    const [searchText, setSearchText] = useState("")
    const { eventoSelecionado } = useContext(EventosContext)

    const displayedOptions = useMemo(
        () => options.filter((option) => Teste(option[label], searchText)),
        [searchText]
    )

    const getSelectedValue = () => {
        let teste = options.find(op => op.id == eventoSelecionado.id_hashtag)
        if (teste) {
            return teste.id
        } else {
            return 0
        }
    }

    return (
        <Box >
            {options &&
                <FormControl sx={{ width: '100%', color: 'black' }}>
                    {/* <Typography id="search-select-label">Revenda</Typography> */}
                    <Select
                        name={name}
                        sx={{ ...sxSelect, backgroundColor: disabled ? "#c9c7c7" : "white" }}
                        value={getSelectedValue()}
                        MenuProps={{
                            autoFocus: false,
                            PaperProps: { sx: sxMenuPaper },
                            sx: { '& .Mui-selected': { backgroundColor: '#9d56b93f' } }
                        }} // Disables auto focus on MenuItems and allows TextField to be in focus
                        inputProps={{
                            sx: { padding: '0 5px' }
                        }}
                        labelId="search-select-label"
                        IconComponent={KeyboardArrowDown}
                        id="navbar_revenda_select"
                        onChange={onChange}
                        onClose={() => setSearchText("")}
                        disabled={disabled}
                        {...rest}
                        // This prevents rendering empty string in Select's value
                        // if search text would exclude currently selected option.
                        // renderValue={() => options.nome}
                    >
                        {/* TextField is put into ListSubheader so that it doesn't
              act as a selectable item in the menu
              i.e. we can click the TextField without triggering any selection. */}
                        <ListSubheader>
                            <TextField
                                size="small"
                                // Autofocus on textfield
                                autoFocus
                                placeholder="Pesquisar..."
                                fullWidth
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Search />
                                        </InputAdornment>
                                    )
                                }}
                                onChange={(e) => setSearchText(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key !== "Escape") {
                                        // Prevents autoselecting item while typing (default Select behaviour)
                                        e.stopPropagation()
                                    }
                                }}
                            />
                        </ListSubheader>
                        <MenuItem key={`menu_combo_vazio`} value="0" disabled>
                            Selecione...
                        </MenuItem>
                        {displayedOptions.map((option, i) => (
                            <MenuItem sx={{ height: '30px' }} key={`menu_combo_${i}`} value={option[labelId]}>
                                {option[label]}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </Box>
    )
}
